/*
 * Copyright (c) ProviderTrust LLC.
 * All Rights Reserved.
 *
 * This software is confidential and proprietary information of
 * ProviderTrust LLC ("Confidential Information"). You shall not disclose
 * such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with ProviderTrust.
 */
import ecPDFTemplate from "./ecPDFTemplate"
import * as JsPDF from "jspdf"
import "jspdf-autotable"

const defaultMarginX = 2.5
const defaultMarginY = 1.25
const defaultFontSize = 12

function width(doc) {
  return doc.internal.pageSize.width || doc.internal.pageSize.getWidth()
}

export default class PDFReport {
  constructor(
    template = ecPDFTemplate,
    marginX = defaultMarginX,
    marginY = defaultMarginY,
    fontSize = defaultFontSize
  ) {
    this.template = template
    this.marginX = marginX * fontSize
    this.currentY = marginY * fontSize
    this.fontSize = fontSize

    // TODO not used for now, but useful in the future
    // this.marginY = marginY * fontSize;
    // this.currentX = this.marginX;
  }

  generatePDF(fileName = "report.pdf", data = {}) {
    const doc = new JsPDF({
      compress: true,
      unit: "pt",
      orientation: "landscape"
    })

    // https://github.com/simonbengtsson/jsPDF-AutoTable/issues/186
    doc.autoTable.previous = false

    const parsedTemplate = this.template(data)
    if (parsedTemplate.tableSetting) {
      doc.autoTableSetDefaults(parsedTemplate.tableSetting)
    }

    for (let content of parsedTemplate.contents) {
      if (content.type === "image") {
        this._renderImage(doc, content)
      } else if (content.type === "text") {
        this._renderText(doc, content)
      } else if (content.type === "table") {
        this._renderTable(doc, content)
      }
    }

    doc.save(fileName)
  }

  _renderImage(doc, { data, width, height, marginX = 0, marginY = 0 }) {
    this.currentY += marginY * this.fontSize
    height = height * this.fontSize
    width = width * this.fontSize
    doc.addImage(
      data,
      "png",
      this.marginX + marginX,
      this.currentY,
      width,
      height,
      "",
      "FAST"
    )
    this.currentY += height
  }

  _renderText(
    doc,
    { data, align = "left", fontSize = 1, fontType = "normal", marginY = 0 }
  ) {
    const height = fontSize * this.fontSize
    doc.setFontSize(height)
    doc.setFontType(fontType)
    this.currentY += marginY * this.fontSize + height

    doc.text(
      data,
      align === "left" ? this.marginX : width(doc) - this.marginX,
      this.currentY,
      null,
      null,
      align
    )
  }

  _renderTable(doc, { data = {}, marginY = 0, tableSetting }) {
    let headers, rows
    if (data.headers && data.rows) {
      headers = data.headers
      rows = data.rows
    } else {
      headers = Object.keys(data)
      rows = [Object.values(data)]
    }

    doc.autoTable(headers, rows, {
      ...tableSetting,
      startY:
        (doc.autoTable.previous
          ? doc.autoTable.previous.finalY
          : this.currentY) +
        marginY * this.fontSize
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/pdfreport/PDFReport.js